import {BID_STATUS, BID_STATUS_USES, BID_SEVERITY_STATUS} from '@shared/data/bid-status-uses-data';
import {BID_MAP_STATUS_DEFAULT_PIN_FILL} from './bid-map-colors';

export type BidSeverityTone = 'info' | 'success' | 'danger';

export function getBidStatusSeverityTone(statusId: number | null): BidSeverityTone {
  if (statusId == null) {
    return 'info';
  }
  const raw = BID_SEVERITY_STATUS[String(statusId)];
  if (raw === 'success' || raw === 'danger' || raw === 'info') {
    return raw;
  }
  return 'info';
}

export function pinHexForBidSeverityTone(tone: BidSeverityTone): string {
  switch (tone) {
    case 'success':
      return '#16A34A';
    case 'danger':
      return '#DC2626';
    default:
      return BID_MAP_STATUS_DEFAULT_PIN_FILL;
  }
}

export function normalizeBidStatusId(raw: string | number | null | undefined): number | null {
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    const n = Math.trunc(raw);
    if (n >= BID_STATUS.New && n <= BID_STATUS.Archive) {
      return n;
    }
    return null;
  }
  const s = String(raw).trim();
  const asInt = parseInt(s, 10);
  if (!Number.isNaN(asInt) && asInt >= BID_STATUS.New && asInt <= BID_STATUS.Archive) {
    return asInt;
  }
  if (Object.prototype.hasOwnProperty.call(BID_STATUS, s)) {
    const v = (BID_STATUS as unknown as Record<string, number | string>)[s];
    if (typeof v === 'number' && v >= BID_STATUS.New && v <= BID_STATUS.Archive) {
      return v;
    }
  }
  const compact = s.toLowerCase().replace(/\s+/g, '');
  const nameMap: Record<string, number> = {
    new: BID_STATUS.New,
    active: BID_STATUS.Active,
    inprogress: BID_STATUS.InProgress,
    finished: BID_STATUS.Finished,
    rejected: BID_STATUS.Rejected,
    canceled: BID_STATUS.Canceled,
    cancelled: BID_STATUS.Canceled,
    archive: BID_STATUS.Archive,
    archived: BID_STATUS.Archive,
  };
  if (compact in nameMap) {
    return nameMap[compact];
  }
  for (const row of BID_STATUS_USES) {
    for (const v of Object.values(row.names)) {
      if (v === s) {
        return row.id;
      }
    }
  }
  return null;
}
